import { StandardAlertsPlugin } from 'src/plugins/alert/alertPlugin';
const mimeTypeSets = {
    'image': ['jp2', 'webp', 'jpeg', 'png'],
    'video': ['avi', 'mp4', 'mpg', 'webm', 'wmv']
};
const mimeTypeValues = {
    '0000000C': ['jp2'],
    'FF4FFF51': ['jp2'],
    '52494646': ['webp', 'avi'],
    'FFD8FF': ['jpeg', 'jpg'],
    '89504E47': ['png'],
    '66747970': ['mp4'],
    '000001B3': ['mpg'],
    '000001BA': ['mpg'],
    '1A45DFA3': ['webm'],
    '3026B275': ['wmv'],
    'A6D900AA': ['wmv'],
    'D0CF11E0': [
        'ppt', 'xls', 'doc'
    ],
    '504B0304': [
        'pptx', 'xlsx', 'docx'
    ],
    '504B0506': [
        'pptx', 'xlsx', 'docx'
    ],
    '504B0708': [
        'pptx', 'xlsx', 'docx'
    ],
    '25504446': ['pdf']
};
/**
 * Check for the hex in the file
 * to catch the actual mime type
 */
const MagicNumberCheckerPlugin = () => {
    const { errorAlert } = StandardAlertsPlugin();
    function checkWithApprovedTypes(
    // i.e ".jpeg,.png,.jpg""
    acceptedTypes, fileTypeList) {
        let accepted = false;
        let acceptedTypesList = acceptedTypes;
        for (const key in mimeTypeSets) {
            const typedKey = key;
            if (acceptedTypes.indexOf(typedKey) > -1) {
                acceptedTypesList = [
                    ...acceptedTypes,
                    ...mimeTypeSets[typedKey]
                ];
            }
        }
        for (let i = 0; i < fileTypeList.length; i++) {
            if (acceptedTypesList.indexOf(fileTypeList[i]) > -1) {
                accepted = true;
                break;
            }
        }
        return accepted;
    }
    function getMimeType(signature) {
        let fileType = ['unknown'];
        // check signature against the magic number list
        for (const key in mimeTypeValues) {
            const typedKey = key;
            if (signature.includes(typedKey)) {
                fileType = mimeTypeValues[typedKey];
                break;
            }
        }
        return fileType;
    }
    function alertError() {
        errorAlert('File type not allowed');
    }
    function parseFile(file, acceptedTypes, parsedCallback, alertWhenError = true) {
        const filereader = new FileReader();
        filereader.onloadend = function (evt) {
            // file is not ready
            if (evt.target?.readyState !== FileReader.DONE)
                return;
            // get the hex of the file
            const uint = new Uint8Array(evt.target.result);
            const bytes = [];
            uint.forEach((byte) => {
                bytes.push(byte.toString(16));
            });
            const hex = bytes.join('').toUpperCase();
            // get mime type
            const mimedTypes = getMimeType(hex);
            // filetype is unknown
            if (alertWhenError && mimedTypes.indexOf('unknown') > -1) {
                alertError();
                // return. dont need to check
                parsedCallback(file, false);
                return;
            }
            // check if mimetype if accepted
            const isApproved = checkWithApprovedTypes(acceptedTypes, mimedTypes);
            if (!isApproved && alertWhenError) {
                alertError();
            }
            parsedCallback(file, isApproved);
        };
        const blob = file.slice(0, 4);
        filereader.readAsArrayBuffer(blob);
    }
    return {
        parseFile,
        checkWithApprovedTypes
    };
};
export { MagicNumberCheckerPlugin };
